export const objectKeys = <Keys extends string>(arg: Record<Keys, unknown>): Keys[] => Object.keys(arg) as Keys[]
